import { setDefaultValues } from 'loader-base';

const setDefaultValuesEc = function setDefaultValuesEc(loaderConfig) {
    setDefaultValues(loaderConfig);
    loaderConfig.additionalComponents = loaderConfig.additionalComponents || [];
    loaderConfig.ignore = loaderConfig.ignore || [];
};

export { setDefaultValuesEc as default };



// WEBPACK FOOTER //
// ./src/default-values-ec.js